import { createSlice } from "@reduxjs/toolkit"
import {current} from "@reduxjs/toolkit"

export const initialState = {
    basket: [],
}




const cartSlice = createSlice({
    name:"cart",
    initialState,
    reducers: {
        addToCart: (state, action) => {
            state.basket.push(action.payload)

        },
        removeFromCart: (state, action) => {
            
            const removeIndex = state.basket.findIndex(item=> item.id === action.payload)
            const newArr = [...state.basket]

            if(removeIndex >= 0){
                newArr.splice(removeIndex, 1)
            }
            else{
                console.warn(`Item not found as no item with id ${action.payload} exists in the current cart`)
            }
            state.basket = newArr

            },
        clearCart: (state) => {
            state.basket = []
        
        }
            
    }

}
)

export default cartSlice.reducer

export const{addToCart, removeFromCart, clearCart} = cartSlice.actions